import type { FaireOrderEntity } from "../../entity_types/order";

export const defaultOrder: FaireOrderEntity = {
  token: "default",
  type: "order",
  customerName: "Default Customer",
  firstOrder: false,
  orderNumber: "DEFAULT-ORDER",
  status: "new",
  totalDollars: 0,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
